"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapboxMap = void 0;
const react_1 = __importDefault(require("react"));
const mapbox_gl_1 = __importDefault(require("mapbox-gl"));
const context_1 = require("./context");
const MapboxMap = ({ token, mapboxOptions, children, onStyleLoad, control, scrollZoom, }) => {
    const [ready, setReady] = react_1.default.useState(false);
    const [map, setMap] = react_1.default.useState();
    const [container, setContainer] = react_1.default.useState();
    react_1.default.useEffect(() => {
        if (container) {
            mapbox_gl_1.default.accessToken = token;
            const map = new mapbox_gl_1.default.Map(Object.assign({ container }, mapboxOptions));
            if (control) {
                map.addControl(new mapbox_gl_1.default.NavigationControl(), "bottom-left");
            }
            if (scrollZoom === false) {
                map.scrollZoom.disable();
            }
            map.on("load", (evt) => {
                setReady(true);
                if (onStyleLoad) {
                    onStyleLoad(map, evt);
                }
            });
            setMap(map);
        }
    }, [setMap, container]); // eslint-disable-line react-hooks/exhaustive-deps
    return (react_1.default.createElement(context_1.MapContext.Provider, { value: map },
        react_1.default.createElement("div", { style: { width: "100%", height: "100%" }, ref: (x) => setContainer(x) }, ready && children)));
};
exports.MapboxMap = MapboxMap;
//# sourceMappingURL=map.js.map